module.exports = __webpack_public_path__ + "img/@logo_sm.72f3d791.png";